export default __webpack_public_path__ + "static/media/iconRemove.d0272e88.svg";